import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout';

import Inicio from '../pages/Inicio';
import Alimentacion from '../pages/Alimentacion';
import Ejercicio from '../pages/Ejercicio';
import Contacto from '../pages/Contacto';


function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/tusalud" element={<Inicio />} exact />
            <Route path="/alimentacion" element={<Alimentacion />} exact />
            <Route path="/ejercicio" element={<Ejercicio />} exact />
            <Route path="/contacto" element={<Contacto />} exact />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>

  );
}



export default App;